import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-brand-blue text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company */}
          <div>
            <div className="text-2xl font-bold mb-4">Appeal Advantage</div>
            <p className="text-brand-blue-100 text-sm">
              Professional property tax appeal management software trusted by tax professionals nationwide.
            </p>
          </div>
          
          {/* Product */}
          <div>
            <h4 className="font-bold mb-4">Product</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/services" className="text-brand-blue-100 hover:text-white transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-brand-blue-100 hover:text-white transition-colors">
                  Solutions
                </Link>
              </li>
              <li>
                <a
                  href="https://app.appealadvantage.com"
                  className="text-brand-blue-100 hover:text-white transition-colors"
                >
                  Platform
                </a>
              </li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <h4 className="font-bold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-brand-blue-100 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-brand-blue-100 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Legal */}
          <div>
            <h4 className="font-bold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <span className="text-brand-blue-100">Privacy Policy</span>
              </li>
              <li>
                <span className="text-brand-blue-100">Terms of Service</span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom */}
        <div className="border-t border-brand-blue-400 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-brand-blue-100">
              © {new Date().getFullYear()} Appeal Advantage. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

